import React from 'react'
import { Space, Button, Input, Form, InputNumber, Badge } from 'antd';
import { SearchOutlined } from '@ant-design/icons'
import Highlighter from 'react-highlight-words';

export const getColumnSearchProps = (title, dataIndex, [ searchText, setSearchText ], [ searchedColumn, setSearchedColumn ], callbackRender = (data) => <>{data}</>) => {

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0])
        setSearchedColumn(dataIndex)
    };
    
    const handleReset = clearFilters => {
        clearFilters();
        setSearchText('')
    };

    let searchInput = null;

    return ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={node => {
                searchInput = node;
              }}
              placeholder={`Search ${title}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                Reset
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                    confirm({ closeDropdown: false });
                    setSearchText(selectedKeys[0])
                    setSearchedColumn(dataIndex)
                }}
              >
                Filter
              </Button>
            </Space>
          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        // onFilterDropdownOpenChange: visible => {
        //   if (visible && searchInput) {
        //     setTimeout(() => searchInput.select(), 100);
        //   }
        // },
        filterDropdownProps: {
            onOpenChange: visible => {
                if (visible && searchInput) {
                  setTimeout(() => searchInput.select(), 100);
                }
              },
        },
        render: (text, rowData) => searchedColumn === dataIndex ? 
          (
            callbackRender(
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
              />,
              rowData
            )
          ) 
          : (
            callbackRender(text,rowData)
          )    
    })
}

export const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  children,
  ...restProps
}) => {

  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export const getColumnsFilterTag = (options) => {
  // const sortedOptions = Object.values(options).sort((a, b) => a.status - b.status);
  
  return Object.values(options).map((o) => ({
    text: (
      <div
        style={{
          backgroundImage: o.bgImg,
          backgroundColor: o.bgColor,
          display: "inline-block",
          padding: "3px 13px",
          borderRadius: "30px",
          border: `1px solid ${o.outline}`
        }}
      >
        {o.icon ? (
          <span style={{ display: "flex", alignItems: "center" }}>
            {o.icon && <img src={o.icon} alt="icon" style={{ width: "15px" }} />}
            <span style={{ color: o.colorTag, marginLeft: "5px" }}>{o.name}</span>
          </span>
        ) : (
          <Badge
            color={o.colorTag}
            text={
              <span style={{ color: o.colorTag }}>{o.name}</span>
            }
          />
        )}
      </div>
    ),
    value: o.status,
  }));
};

export const getColumnsFilterType = (options) => {
  return Object.values(options).map((o) => ({
    text: o.name,
    value: o.value,
  }));
};

export const dataByStatus = (params = {}, newFltrd = [], status) => {

  let newData = { all: newFltrd }
  let len = { all: 0 }

  Object.values(params).reduce((acc, key) => {
    len[key] = 0;  
    newData[key] = newFltrd?.filter(a => (status === 'all' ? a : a.status === status))
    return len;
  }, {});
  
  newFltrd.forEach(m => {
    len.all++; 
    const statusKey = Object.values(params).find(key => key === m.status);
    if (statusKey) {
      len[statusKey]++; 
    }
  });

  return { len, newData };
};

export const allLabelHDLR = (a, b) => {
    return a.length === b.length && a.every((val, index) => val === b[index]);
}